import React, { FC, ReactNode } from 'react';

interface ErrorAlertProps {
  title: string;
  children?: ReactNode;
}

const ErrorAlert: FC<ErrorAlertProps> = ({ title, children }) => (
  <div style={{
    border: '1px solid var(--red-200)',
    backgroundColor: 'var(--red-50)',
    borderRadius: '0.375rem',
    padding: '1rem 1.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  }}>
    <p style={{ fontSize: '0.875rem', fontWeight: 500, color: 'var(--red-700)' }}>{title}</p>
    {children}
  </div>
);

export default ErrorAlert;
